/**
 * SSE handlers explicit declaration
 */
import * as StaffHandlers from './Staff';
import * as CorporationHandlers from './Corporation';

const handlers = [
    ...Object.values(StaffHandlers),
    ...Object.values(CorporationHandlers)
];

export default handlers;